import Link from 'next/link'
import { Button } from '@/components/ui/button'

interface ClientBottomCTAProps {
  buildLoginRedirect: (target: string) => string
}

export default function ClientBottomCTA({ buildLoginRedirect }: ClientBottomCTAProps) {
  const registrationHref = buildLoginRedirect('/client/projects/new?from=landing_bottom_primary')

  return (
    <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-16 md:py-20 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="relative overflow-hidden rounded-3xl border border-gray-200 bg-gradient-to-br from-[#06f] via-[#005eeb] to-[#0054d1] px-5 py-10 text-center text-white shadow-xl sm:px-8 sm:py-12 md:px-12 md:py-14">
          {/* Subtle pattern & glow effects */}
          <div className="pointer-events-none absolute inset-0 opacity-30">
            <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/20 blur-3xl" />
            <div className="absolute -right-24 -bottom-24 h-72 w-72 rounded-full bg-black/20 blur-3xl" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.18),transparent_45%),radial-gradient(circle_at_80%_30%,rgba(0,0,0,0.12),transparent_55%)]" />
          </div>

          <div className="relative z-10">
            {/* 헤드라인 */}
            <h2 className="mx-auto max-w-3xl text-[22px] font-semibold leading-snug tracking-[-0.02em] sm:text-3xl sm:leading-tight md:text-4xl lg:text-5xl">
              3분 등록으로 검증된 팀 견적을 받아보세요
            </h2>

            {/* 서브 */}
            <p className="mx-auto mt-4 max-w-2xl text-base text-white/90 sm:text-lg md:text-xl">
              무료 10회 요청으로 비교 후, 원할 때만 팀을 선택할 수 있습니다.
            </p>

            {/* 근거 칩 3개 */}
            <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
              <span className="inline-flex items-center rounded-full bg-white/20 px-3 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
                3분 등록
              </span>
              <span className="inline-flex items-center rounded-full bg-white/20 px-3 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
                10회 무료 요청
              </span>
              <span className="inline-flex items-center rounded-full bg-white/20 px-3 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
                평균 6시간 첫 응답
              </span>
            </div>

            {/* CTA 버튼 */}
            <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:mt-8">
              <Button
                asChild
                className="h-14 w-full max-w-md rounded-xl bg-white px-10 text-[#06f] shadow-lg transition-all hover:bg-white/90 hover:shadow-xl font-semibold text-base whitespace-nowrap"
              >
                <Link href={registrationHref}>
                  무료로 견적 요청 시작하기
                </Link>
              </Button>
              
              {/* 마이크로카피 */}
              <p className="text-sm text-white/80 max-w-md text-center">
                추가 요청은 크레딧으로 확장합니다 (1요청=1크레딧)
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  )
}

